import { render, staticRenderFns } from "./DeleteConfirmModalComponent.vue?vue&type=template&id=70aa24d9&"
import script from "./DeleteConfirmModalComponent.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmModalComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports